var moduleMap = {
	"./mount": () => {
		return Promise.all(/* __federation_expose_mount */[__webpack_require__.e(9967), __webpack_require__.e(7367), __webpack_require__.e(3788), __webpack_require__.e(2082), __webpack_require__.e(426), __webpack_require__.e(6823)]).then(() => (() => ((__webpack_require__(32002)))));
	},
	"./Editor": () => {
		return Promise.all(/* __federation_expose_Editor */[__webpack_require__.e(9967), __webpack_require__.e(7367), __webpack_require__.e(3788), __webpack_require__.e(2082), __webpack_require__.e(426), __webpack_require__.e(6823)]).then(() => (() => ((__webpack_require__(32002)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});